<template>
  <div class="time">
    <p class="meetingTitle" v-if="isAppoint">{{ meetingName }}</p>
    <p v-if="!isAppoint">
      {{ nowDate }}&nbsp;{{
        nowWeek
      }}&nbsp;{{ nowTime }}
    </p>
    <!-- <div class="register" @click="innerRegister" v-if="!isinnerRegister">
      <div class="register-tip">内部员工签到</div>
    </div> -->
    <div v-if="!isIndex" class="revert" @click="revert"></div>
    <!-- <div v-if="!isIndex" class="icon" @click="toIndex"></div> -->
    <div class="refresh" @click="refreshfun"></div>
    <el-dialog
      title=""
      :visible.sync="showCheckRegister"
      center
      class="registerClass"
      append-to-body
      :style="{ fontFamily: fonts }"
      :show-close="false"
    >
      <div class="registerText">选择你的岗位</div>
      <span slot="footer" class="dialog-footer">
        <div class="registerfooter">
          <el-button class="btn btn1" @click="gotoRegister(1)"
            >防疫员</el-button
          >
          <el-button class="btn btn2" @click="gotoRegister(2)"
            >保洁员</el-button
          >
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getMeetModel } from "@/utils/request";
export default {
  name: "HomeHeader",
  props: {
    // font: {
    //   type: String,
    //   default: ""
    // },
    curname: {
      type: String,
      default: ""
    }
  },
  watch: {
    curname(n, o) {
      //n为新值,o为旧值;
      console.log(n, o);
      this.meetingName = n;
    }
  },
  data() {
    return {
      fonts: this.font,
      meetingName: this.curname,
      nowTime: "",
      isIndex: false,
      isAppoint: false,
      register: false,
      isinnerRegister: false,
      nowDate: "",
      nowWeek: "",
      timer: null,
      showCheckRegister: false
    };
  },
  created() {
    console.log(this.curname);
    // console.log(this.$route.path)
    if (
      this.$route.path === "/homePage" ||
      this.$route.path === "/advertising"
    ) {
      this.isIndex = true;
    } else if (this.$route.path === "/appoint") {
      this.isAppoint = true;
    } else if (this.$route.path === "/innerRegister") {
      this.isinnerRegister = true;
    } else if (this.$route.path === "/register") {
      this.register = true;
    }
  },
  mounted() {
    let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
    // this.meetingName = this.name;
    this.setNowTimes();
    this.getMeetModels();
    this.timer = setInterval(() => {
      _this.setNowTimes();
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  },
  methods: {
    getMeetModels() {
      getMeetModel().then(res => {
        if (Number(res.code) === 0) {
          this.fonts = res.data.fontStyle;
          this.$emit("changeFont", res.data.fontStyle);
        }
      });
    },
    // 时间格式化
    setNowTimes() {
      let myDate = new Date();
      // console.log(myDate)
      let wk = myDate.getDay();
      let yy = myDate.getFullYear();
      let mm = myDate.getMonth() + 1;
      let dd = myDate.getDate();
      let hou = myDate.getHours();
      let min = myDate.getMinutes();
      let sec = myDate.getSeconds();
      let weeks = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      let week = weeks[wk];
      if (mm >= 1 && mm <= 9) {
        mm = "0" + mm;
      }
      this.nowDate = yy + "-" + mm + "-" + dd;
      this.nowTime =
        (Number(hou) < 10 ? "0" + hou : hou) +
        ":" +
        (Number(min) < 10 ? "0" + min : min)+
        ":" +
        (Number(sec) < 10 ? "0" + sec : sec);
      this.nowWeek = week;
    },
    revert() {
      history.back();
    },
    toIndex() {
      this.$router.push({
        path: "/homePage",
        query: {
          equipmentName: this.$route.query.equipmentName,
          meetingId: this.$route.query.meetingId,
          meetingName: this.$route.query.meetingName
        }
      });
    },
    innerRegister() {
      this.showCheckRegister = true;
      // this.$router.push({path: '/innerRegister', query: {equipmentName: this.$route.query.equipmentName, meetingId: this.$route.query.meetingId, meetingName:this.$route.query.meetingName}})
    },
    gotoRegister(type) {
      this.$router.push({
        path: "/innerRegister",
        query: {
          equipmentName: this.$route.query.equipmentName,
          meetingId: this.$route.query.meetingId,
          meetingName: this.$route.query.meetingName,
          type: type
        }
      });
    },
    refreshfun() {
      this.$router.push({
        path: "/"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.time {
  width: 100%;
  height: 10%;
  background-color: rgba(76, 95, 162, 0.4);
  display: flex;
  // position: absolute;
  // top: 0;
  // left: 0;
  p {
    width: 95%;
    text-align: center;
    color: #fff;
    height: 100%;
    font-size: 43px;
    letter-spacing: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  p.meetingTitle {
    display: inline-block;
    padding-left: 3%;
    text-align: left;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .register {
    width: 5%;
    height: 100%;
    background: url(../assets/register.png) no-repeat;
    background-position: center;
    position: relative;
    z-index: 100;
    .register-tip {
      position: absolute;
      width: 270px;
      height: 91px;
      display: flex;
      align-items: center;
      justify-content: center;
      bottom: -70px;
      left: -200px;
      background: url("../assets/register-tip.png") no-repeat;
      color: #ffb668;
      font-size: 36px;
    }
  }
  .icon {
    width: 5%;
    height: 100%;
    background: url(../assets/home.png) no-repeat;
    background-position: center;
    // margin-top: 30px
  }
  .revert {
    width: 5%;
    height: 100%;
    background: url(../assets/back.png) no-repeat;
    background-position: center;
    // margin-top: 30px
  }
  .refresh {
    width: 5%;
    height: 100%;
    background: url(../assets/refresh.png) no-repeat;
    background-position: center;
  }
}
.registerClass {
  /deep/.el-dialog {
    border-radius: 20px;
    width: 813px;
    height: 372px;
    .registerText {
      color: #333;
      font-size: 48px;
      text-align: center;
    }
    .registerfooter {
      display: flex;
      padding: 63px 140px 0;
      .btn {
        // flex: 1;
        // padding: 14px 30px;
        width: 192px;
        height: 68px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 36px;
        color: #fff;
        background: #dadada;
        border: none;

        border-radius: 2px;
      }
      .btn1 {
        background: linear-gradient(0deg, #1bf7e9, #2ad7ff);
        margin-right: 145px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue